import {
  faBriefcase,
  faCarBus,
  faCogs,
  faDollarSign,
  faFarm,
  faHandsHeart,
  faHeartbeat,
  faHotel,
  faLandmark,
  faMegaphone,
  faSchool,
  faSitemap,
  faBalanceScale,
  faCameraMovie,
  faCity,
  faPhoneLaptop,
  faUserHardHat,
  IconDefinition,
} from '@fortawesome/pro-solid-svg-icons'

type IndustryIconMap = {
  [key: string]: IconDefinition
}

const industryIconMap: IndustryIconMap = {
  'Agriculture, Food & Natural Resources': faFarm,
  'Architecture & Construction': faCity,
  'Arts, Audio/Video Technology & Communications': faCameraMovie,
  'Business Management & Administration': faSitemap,
  'Education & Training': faSchool,
  Finance: faDollarSign,
  'Government & Public Administration': faLandmark,
  'Health Science': faHeartbeat,
  'Hospitality & Tourism': faHotel,
  'Human Services': faHandsHeart,
  'Information Technology': faPhoneLaptop,
  'Law, Public Safety, Corrections & Security': faBalanceScale,
  Manufacturing: faUserHardHat,
  Marketing: faMegaphone,
  'Science, Technology, Engineering & Mathematics': faCogs,
  'Transportation, Distribution & Logistics': faCarBus,
} as const

export default industryIconMap

const defaultIcon = faBriefcase
export const getIndustryIcon = (industry: string): IconDefinition => {
  return industryIconMap[industry] || defaultIcon
}
